export const EXCEL_EXTENSIONS = [".xlsx", ".xlsm", ".xlsb", ".xls", ".ods"];

export const TABLE_FILE_EXTENSIONS = [
  ".csv",
  ".tsv",
  ".parquet",
  ".pq",
  ...EXCEL_EXTENSIONS,
];

export const TABLE_FILE_FORMATS = TABLE_FILE_EXTENSIONS.join(" · ");

/** The dashed frame every drop target draws, accent once a drag is over it. */
export function dropFrameClass(armed: boolean): string {
  return `border border-dashed rounded-app transition-colors ${
    armed ? "border-accent bg-accent-subtle/30" : "border-border"
  }`;
}
